const selectors: Record<"article" | "articleTrigger" | "articleDialog", string> = {
  article: "[data-article]",
  articleTrigger: "[data-article-trigger]",
  articleDialog: "[data-article-dialog]",
};

const init = () => {
  const articles = document.querySelectorAll(selectors.article);

  articles?.forEach((article) => {
    const dialogTrigger = article.querySelector(selectors.articleTrigger) as HTMLElement;
    const dialog = article.querySelector(selectors.articleDialog) as HTMLDialogElement;

    dialogTrigger.addEventListener("click", () => dialog.showModal());
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    setTimeout(() => {
      init();
    }, 0);
  },
  {
    once: true,
  }
);
